import { selectedLocation } from '$lib/PersistedState.svelte.js';
import { fetchAndStoreDataByLocation } from '$lib/dataLoader.js';

import logger from '$lib/logger.js';

export async function load({ parent }) {
  await parent();

  if (selectedLocation.current) {
    const locationId = parseInt(selectedLocation.current);
    logger.info(`Syncing for ${locationId}`);
    fetchAndStoreDataByLocation(locationId);
  }

  return {};
}
